import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import FormItemLabel from './form-item-label.vue';
import OrientationItem from './orientation-item.vue';
import LanguageItem from './language-item.vue';
import PsdItem from './psd-item.vue';
import QualityItem from './quality-item.vue';
import Uploader from '@/components/Uploader';
import { getAppInfo as _getAppInfo } from '@pt/api/common';
import { createGmakerProject, updateGmakerProject } from '@pt/api/gmaker/project.js';
import regexp from '@com/utils/regexp.js';
import { platformList } from '@com/utils/platform.js';
import { ptTrackEvent } from '@com/utils/report-logs/pt';

var promotedType = [{
  value: 'app',
  label: 'app'
}, {
  value: 'website',
  label: 'website'
}];

export default {
  name: 'creativeInfo.vue',

  props: {
    // 类型，枚举值 'create', 'update'
    action: {
      type: String,
      default: 'create',
      validator: function validator(value) {
        return ['create', 'update', 'copy'].indexOf(value) !== -1;
      }
    },

    // 作品类型，枚举值 'normal',, 'playsmart'
    type: {
      type: String,
      default: 'normal',
      validator: function validator(value) {
        return ['normal', 'playsmart', 'free', 'playsmartByPsd', 'iv'].indexOf(value) !== -1;
      }
    },

    updateRequest: {
      type: Function
    },

    createRequest: {
      type: Function
    },

    // 模板 id，create 时需要传
    templateId: {
      type: Number
    },

    // 作品信息，update 时需要传
    creativeInfo: {
      type: Object
    },

    // 作品 id，update 与 copy 时需要
    id: {
      type: Number
    },

    loading: {
      type: Boolean,
      default: false
    },

    readMode: {
      type: Boolean,
      default: false
    },

    schema: {
      type: Object
    },

    // 皮肤 id，通过通用模板创建版本时用到
    skinId: {
      type: Number
    }
  },

  components: {
    FormItemLabel: FormItemLabel,
    OrientationItem: OrientationItem,
    Uploader: Uploader,
    LanguageItem: LanguageItem,
    PsdItem: PsdItem,
    QualityItem: QualityItem
  },

  data: function data() {
    return {
      model: {
        name: '',
        platform: '',
        orientation: '',
        language: '',
        psdUrl: '',
        quality: 80,

        promotedType: '',

        appUrl: '',
        appIcon: '',
        appName: '',
        appUrlInSystem: false,

        iOSAppUrl: '',
        iOSAppIcon: '',
        iOSAppName: '',
        iOSAppUrlInSystem: false,

        androidAppUrl: '',
        androidAppIcon: '',
        androidAppName: '',
        androidAppUrlInSystem: false
      },
      formConfig: {
        // labelPosition: 'left',
        // labelWidth: '115px'
      },

      pullingAppInfo: false,
      pullingIOSAppInfo: false,
      pullingAndroidAppInfo: false,
      appInfoEditable: false,
      iOSAppInfoEditable: false,
      androidAppInfoEditable: false,
      appUrlInputFocus: false,
      iOSAppUrlInputFocus: false,
      androidAppUrlInputFocus: false,

      tips: {
        appIcon: this.$t('playTurbo.commonTemplate.creativeInfo.form.appIcon.tips'),
        appName: this.$t('playTurbo.commonTemplate.creativeInfo.form.appName.tips')
      },
      label: {
        appIcon: this.$t('playTurbo.commonTemplate.creativeInfo.form.appIcon.label'),
        appName: this.$t('playTurbo.commonTemplate.creativeInfo.form.appName.label')
      },
      form: null,
      popoverAttrs: {
        placement: 'top',
        trigger: 'hover',
        width: '200px'
      },
      previewImageStyle: 'display:block;margin: 0 auto;max-width: 120px;max-height: 120px;',
      psdSuccess: null,
      psdMessage: []
    };
  },


  computed: {
    submitButton: function submitButton() {
      return {
        type: 'primary',
        text: this.$t('common.confirmButtonText'),
        disabled: this.loading || this.pullingIOSAppInfo || this.pullingAndroidAppInfo || this.readMode,
        loading: this.loading
      };
    },
    cancelButton: function cancelButton() {
      return {
        text: this.$t('common.cancelButtonText'),
        disabled: this.loading
      };
    },
    appInfoVisible: function appInfoVisible() {
      return this.model.promotedType === 'website';
    },
    isPlaySmartType: function isPlaySmartType() {
      return this.type === 'playsmart';
    },
    isPlaySmartByPsdType: function isPlaySmartByPsdType() {
      return this.type === 'playsmartByPsd';
    },
    isIvType: function isIvType() {
      return this.type === 'iv';
    },
    isFreeEdit: function isFreeEdit() {
      return this.type === 'free';
    },
    iOSAppInfoVisible: function iOSAppInfoVisible() {
      return this.isIOS(this.model.platform) && this.model.promotedType === 'app';
    },
    androidAppInfoVisible: function androidAppInfoVisible() {
      return this.isAndroid(this.model.platform) && this.model.promotedType === 'app';
    },
    appNameRules: function appNameRules() {
      return [{
        required: true,
        trigger: 'blur',
        message: this.$t('playTurbo.commonTemplate.creativeInfo.form.appName.empty')
      }, {
        min: 1,
        max: 50,
        trigger: 'blur'
      }];
    },
    appUrlRules: function appUrlRules() {
      return [{
        required: true,
        trigger: 'blur',
        message: this.$t('playTurbo.commonTemplate.creativeInfo.form.url.empty')
      }, {
        min: 1,
        max: 2000,
        trigger: 'blur'
      }, {
        validator: this.urlValidator,
        trigger: 'blur'
      }];
    },
    appInfoSchema: function appInfoSchema() {
      var _this = this;

      // app url 为空时，app icon 和 app name 不可编辑
      return {
        appUrl: {
          visible: this.appInfoVisible && this.action !== 'copy',
          label: this.$t('playTurbo.commonTemplate.creativeInfo.form.url.label'),
          prop: 'appUrl',
          field: {
            placeholder: this.$t('playTurbo.commonTemplate.creativeInfo.form.url.placeholder'),
            clearable: true,
            disabled: this.readMode
          },
          rules: this.appUrlRules
        },
        appIcon: {
          visible: this.appInfoVisible && this.model.appUrl,
          label: this.label.appIcon,
          desc: this.tips.appIcon,
          prop: 'appIcon',
          rules: [{
            required: true,
            trigger: 'change'
          }],
          field: {
            disabled: this.appUrlInputFocus || this.pullingAppInfo || this.readMode,
            showFileList: false,
            onSuccess: function onSuccess(res) {
              _this.onUploadSuccess({ res: res, platform: 'website' });
            },
            // beforeUpload: this.beforeUpload,
            accept: '.jpg,.jpeg,.png'
          }
        },
        appName: {
          visible: this.appInfoVisible && this.model.appUrl,
          label: this.label.appName,
          desc: this.tips.appName,
          prop: 'appName',
          field: {
            placeholder: '',
            clearable: true,
            disabled: this.appInfoEditable || this.appUrlInputFocus || this.pullingAppInfo || this.readMode
          },
          rules: this.appNameRules
        }
      };
    },
    iOSAppInfoSchema: function iOSAppInfoSchema() {
      var _this2 = this;

      // app url 为空时，app icon 和 app name 不可编辑
      return {
        iOSAppUrl: {
          visible: this.iOSAppInfoVisible,
          label: 'iOS URL',
          prop: 'iOSAppUrl',
          field: {
            placeholder: 'Apple App Store URL.',
            clearable: true,
            disabled: this.readMode
          },
          rules: this.appUrlRules
        },
        iOSAppIcon: {
          visible: this.iOSAppInfoVisible && this.model.iOSAppUrl,
          label: this.label.appIcon,
          desc: this.tips.appIcon,
          prop: 'iOSAppIcon',
          rules: [{
            required: true,
            trigger: 'change'
          }],
          field: {
            disabled: this.iOSAppUrlInputFocus || this.pullingIOSAppInfo || this.readMode,
            showFileList: false,
            onSuccess: function onSuccess(res) {
              _this2.onUploadSuccess({ res: res, platform: 'iOS' });
            },
            // beforeUpload: this.beforeUpload,
            accept: '.jpg,.jpeg,.png'
          }
        },
        iOSAppName: {
          visible: this.iOSAppInfoVisible && this.model.iOSAppUrl,
          label: this.label.appName,
          desc: this.tips.appName,
          prop: 'iOSAppName',
          field: {
            placeholder: '',
            clearable: true,
            disabled: this.iOSAppInfoEditable || this.iOSAppUrlInputFocus || this.pullingIOSAppInfo || this.readMode
          },
          rules: this.appNameRules
        }
      };
    },
    androidAppInfoSchema: function androidAppInfoSchema() {
      var _this3 = this;

      return {
        androidAppUrl: {
          visible: this.androidAppInfoVisible,
          label: 'Android URL',
          prop: 'androidAppUrl',
          field: {
            placeholder: 'Google Play/Android App Store URL.',
            clearable: true,
            disabled: this.readMode
          },
          rules: this.appUrlRules
        },
        androidAppIcon: {
          visible: this.androidAppInfoVisible && this.model.androidAppUrl,
          label: this.label.appIcon,
          desc: this.tips.appIcon,
          prop: 'androidAppIcon',
          rules: [{
            required: true,
            trigger: 'change'
          }],
          field: {
            disabled: this.androidAppUrlInputFocus || this.pullingAndroidAppInfo || this.readMode,
            showFileList: false,
            onSuccess: function onSuccess(res) {
              _this3.onUploadSuccess({ res: res, platform: 'android' });
            },
            // beforeUpload: this.beforeUpload,
            accept: '.jpg,.jpeg,.png'
          }
        },
        androidAppName: {
          visible: this.androidAppInfoVisible && this.model.androidAppUrl,
          label: this.label.appName,
          desc: this.tips.appName,
          prop: 'androidAppName',
          field: {
            placeholder: '',
            clearable: true,
            disabled: this.androidAppInfoEditable || this.androidAppUrlInputFocus || this.pullingAndroidAppInfo || this.readMode
          },
          rules: this.appNameRules
        }
      };
    },
    innerSchema: function innerSchema() {
      var temp = _extends({
        name: {
          label: this.$t('playTurbo.commonTemplate.creativeInfo.form.name.label'),
          prop: 'name',
          field: {
            placeholder: this.$t('playTurbo.commonTemplate.creativeInfo.form.name.placeholder'),
            clearable: true,
            disabled: this.readMode
          },
          rules: [{
            required: true,
            trigger: 'blur',
            message: this.$t('playTurbo.commonTemplate.creativeInfo.form.name.empty')
          }, {
            validator: this.productNameValidator,
            trigger: 'blur'
          }]
        },
        promotedType: {
          visible: this.action !== 'create' && this.action !== 'copy', // 创建弹窗不展示产品信息
          label: this.$t('playTurbo.commonTemplate.creativeInfo.form.promotedType.label'),
          prop: 'promotedType',
          field: {
            clearable: true,
            options: promotedType
          },
          rules: [{
            required: true,
            trigger: 'change',
            message: this.$t('playTurbo.commonTemplate.creativeInfo.form.promotedType.empty')
          }]
        },
        platform: {
          visible: this.action !== 'create' && this.action !== 'copy', // 创建弹窗不展示产品信息
          label: this.$t('playTurbo.commonTemplate.creativeInfo.form.platform.label'),
          prop: 'platform',
          rules: [{
            required: true,
            trigger: 'change',
            message: this.$t('playTurbo.commonTemplate.creativeInfo.form.platform.empty')
          }],
          field: {
            clearable: true,
            options: platformList,
            disabled: this.readMode
          }
        }
      }, this.appInfoSchema, this.iOSAppInfoSchema, this.androidAppInfoSchema);
      return _.merge(temp, this.schema);
    }
  },

  watch: {
    'model.platform': function modelPlatform(val) {
      // 如果切换到 ios & android，不需要清空数据
      if (val === 'ios,android' || this.model.promotedType === 'website') return;

      if (this.isAndroid(val)) {
        this.iOSAppInfoEditable = false;
        this.model.iOSAppUrl = '';
        this.model.iOSAppIcon = '';
        this.model.iOSAppName = '';
        return;
      }

      if (this.isIOS(val)) {
        this.androidAppInfoEditable = false;
        this.model.androidAppUrl = '';
        this.model.androidAppIcon = '';
        this.model.androidAppName = '';
      }
    },
    'model.promotedType': function modelPromotedType(val, oldVal) {
      if (oldVal !== '' && val) {
        this.model.platform = '';
        this.appInfoEditable = false;
        this.model.appUrl = '';
        this.model.appIcon = '';
        this.model.appName = '';
      }
    },


    creativeInfo: {
      handler: function handler(val) {
        this.model = _extends({}, this.model, val);
        this.reviewAppInfo(this.model);
      },

      deep: true
    }
  },

  mounted: function mounted() {
    if (this.action === 'update' || this.action === 'copy') {
      this.model = _extends({}, this.model, this.creativeInfo);
      this.reviewAppInfo(this.model);
    }
    this.form = this.$refs.form;
  },


  methods: {
    isIOS: function isIOS(val) {
      return val.indexOf('ios') > -1;
    },
    isAndroid: function isAndroid(val) {
      return val.indexOf('android') > -1;
    },
    handleAppUrlInputFocus: function handleAppUrlInputFocus(type) {
      if (type === 'iOS') {
        this.iOSAppUrlInputFocus = true;
        this.oldIOSAppUrl = this.model.iOSAppUrl;
      } else if (type === 'website') {
        this.appUrlInputFocus = true;
        this.oldAppUrl = this.model.appUrl;
      } else {
        this.androidAppUrlInputFocus = true;
        this.oldAndroidAppUrl = this.model.androidAppUrl;
      }
    },
    handleAppUrlInputBlur: function handleAppUrlInputBlur(type) {
      if (type === 'iOS') {
        this.iOSAppUrlInputFocus = false;
        if (this.oldIOSAppUrl === this.model.iOSAppUrl) return;
        this.getIOSAppInfo();
      } else if (type === 'website') {
        this.appUrlInputFocus = false;
        if (this.oldAppUrl === this.model.appUrl) return;
        this.getWebsiteAppInfo();
      } else {
        this.androidAppUrlInputFocus = false;
        if (this.oldAndroidAppUrl === this.model.androidAppUrl) return;
        this.getAndroidAppInfo();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var valid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.$refs.form.validate();

              case 2:
                valid = _context.sent;

                console.log(valid);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    productNameValidator: function productNameValidator(rule, value, callback) {
      var re = /^[0-9a-zA-Z_]{1,50}$/;
      if (re.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t('playTurbo.commonTemplate.creativeInfo.form.name.validateMessage')));
      }
    },
    urlValidator: function urlValidator(rule, value, callback) {
      if (regexp.url.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t('playTurbo.commonTemplate.creativeInfo.form.url.valid')));
      }
    },
    onUploadSuccess: function onUploadSuccess(_ref) {
      var _this5 = this;

      var res = _ref.res,
          platform = _ref.platform;

      if (res && res.code === 0) {
        var url = _.get(res, 'data.url');
        var utils = {
          iOS: function iOS() {
            _this5.model.iOSAppIcon = url;
          },
          android: function android() {
            _this5.model.androidAppIcon = url;
          },
          website: function website() {
            _this5.model.appIcon = url;
          }
        };
        utils[platform]();
      } else {
        this.$message.error('Upload Error.');
      }
    },
    beforeUpload: function beforeUpload() {
      return true;
    },


    // 编辑的时候校验远端是否存储该 url 对应的信息，如果有，代表不可编辑，没有，则可编辑
    reviewAppInfo: function reviewAppInfo(creativeInfo) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (creativeInfo.iOSAppUrl) {
                  if (_this6.creativeInfo.iOSAppUrlInSystem) {
                    _this6.iOSAppInfoEditable = true;
                  } else {
                    _this6.iOSAppInfoEditable = false;
                  }
                }

                if (creativeInfo.androidAppUrl) {
                  if (_this6.creativeInfo.androidAppUrlInSystem) {
                    _this6.androidAppInfoEditable = true;
                  } else {
                    _this6.androidAppInfoEditable = false;
                  }
                }

                if (creativeInfo.appUrl) {
                  if (_this6.creativeInfo.appUrlInSystem) {
                    _this6.appInfoEditable = true;
                  } else {
                    _this6.appInfoEditable = false;
                  }
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    getAppInfo: function getAppInfo(url) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _getAppInfo({
                  params: {
                    app_url: url
                  }
                });

              case 2:
                res = _context3.sent;
                return _context3.abrupt('return', _.get(res, 'data.data.info'));

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    getIOSAppInfo: function getIOSAppInfo() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var emptyAppInfo, appInfo, app_name, app_icon;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                emptyAppInfo = function emptyAppInfo() {
                  _this8.iOSAppInfoEditable = false;
                  _this8.model.iOSAppName = '';
                  _this8.model.iOSAppIcon = '';
                };

                emptyAppInfo();

                if (!(!_this8.model.iOSAppUrl || !regexp.url.test(_this8.model.iOSAppUrl))) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _context4.prev = 4;

                _this8.pullingIOSAppInfo = true;

                _context4.next = 8;
                return _this8.getAppInfo(_this8.model.iOSAppUrl);

              case 8:
                appInfo = _context4.sent;

                if (appInfo) {
                  if (appInfo.platform === 'ios') {
                    app_name = appInfo.app_name, app_icon = appInfo.app_icon;

                    _this8.iOSAppInfoEditable = true;
                    _this8.model.iOSAppName = app_name;
                    _this8.model.iOSAppIcon = app_icon;
                  } else {
                    _this8.$message.error('Invalid iOS APP URL');
                  }
                }

                _this8.pullingIOSAppInfo = false;
                _context4.next = 18;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](4);

                console.error(_context4.t0);
                emptyAppInfo();
                _this8.pullingIOSAppInfo = false;

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[4, 13]]);
      }))();
    },
    getWebsiteAppInfo: function getWebsiteAppInfo() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var emptyAppInfo, appInfo, app_name, app_icon;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                emptyAppInfo = function emptyAppInfo() {
                  _this9.appInfoEditable = false;
                  _this9.model.appName = '';
                  _this9.model.appIcon = '';
                };

                emptyAppInfo();

                if (!(!_this9.model.appUrl || !regexp.url.test(_this9.model.appUrl))) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return');

              case 4:
                _context5.prev = 4;

                _this9.pullingAppInfo = true;

                _context5.next = 8;
                return _this9.getAppInfo(_this9.model.appUrl);

              case 8:
                appInfo = _context5.sent;

                if (appInfo) {
                  app_name = appInfo.app_name, app_icon = appInfo.app_icon;

                  _this9.appInfoEditable = true;
                  _this9.model.appName = app_name;
                  _this9.model.appIcon = app_icon;
                }

                _this9.pullingAppInfo = false;
                _context5.next = 18;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5['catch'](4);

                console.error(_context5.t0);
                emptyAppInfo();
                _this9.pullingAppInfo = false;

              case 18:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9, [[4, 13]]);
      }))();
    },
    getAndroidAppInfo: function getAndroidAppInfo() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var emptyAppInfo, appInfo, app_name, app_icon;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                emptyAppInfo = function emptyAppInfo() {
                  _this10.androidAppInfoEditable = false;
                  _this10.model.androidAppName = '';
                  _this10.model.androidAppIcon = '';
                };

                emptyAppInfo();

                if (!(!_this10.model.androidAppUrl || !regexp.url.test(_this10.model.androidAppUrl))) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return');

              case 4:
                _context6.prev = 4;

                _this10.pullingAndroidAppInfo = true;

                _context6.next = 8;
                return _this10.getAppInfo(_this10.model.androidAppUrl);

              case 8:
                appInfo = _context6.sent;

                if (appInfo) {
                  if (appInfo.platform === 'android') {
                    app_name = appInfo.app_name, app_icon = appInfo.app_icon;

                    _this10.androidAppInfoEditable = true;
                    _this10.model.androidAppName = app_name;
                    _this10.model.androidAppIcon = app_icon;
                  } else {
                    _this10.$message.error('Invalid android APP URL');
                  }
                }

                _this10.pullingAndroidAppInfo = false;
                _context6.next = 18;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6['catch'](4);

                console.error(_context6.t0);
                emptyAppInfo();
                _this10.pullingAndroidAppInfo = false;

              case 18:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[4, 13]]);
      }))();
    },
    sendTrackEvent: function sendTrackEvent(_ref2) {
      var _this11 = this;

      var pid = _ref2.pid,
          project_type = _ref2.project_type;

      var action = ptTrackEvent.createAction();
      var getSourcePage = function getSourcePage() {
        var routeName = _this11.$route.name;
        if (routeName === 'home.index') {
          return 'index';
        } else if (routeName.indexOf('creative-assets.template') > -1) {
          return 'person-template';
        } else if (routeName === 'creative-template.lib' || routeName === 'creative-template.star') {
          return 'template';
        } else if (routeName.indexOf('my-project.playable') > -1) {
          return 'list';
        } else if (routeName.indexOf('common-template.custom') > -1) {
          return 'editing';
        }
        return 'other';
      };
      action.log({
        e: 'create_project',
        extra: {
          pid: pid,
          source_page: getSourcePage(),
          project_type: project_type
        }
      });
    },
    submit: function submit() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var valid, apps, utils;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!_this12.readMode) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt('return');

              case 2:
                _context10.next = 4;
                return _this12.$refs.form.validate();

              case 4:
                valid = _context10.sent;

                if (valid) {
                  _context10.next = 7;
                  break;
                }

                return _context10.abrupt('return');

              case 7:
                if (!_this12.isPlaySmartByPsdType) {
                  _context10.next = 14;
                  break;
                }

                if (!(_this12.model.psdUrl === '')) {
                  _context10.next = 11;
                  break;
                }

                _this12.$refs.psdItem.updateErrorForm('empty');
                return _context10.abrupt('return');

              case 11:
                if (!(_this12.psdSuccess === false)) {
                  _context10.next = 14;
                  break;
                }

                _this12.$refs.psdItem.updateErrorForm('error');
                return _context10.abrupt('return');

              case 14:
                apps = [];

                if (_this12.appInfoVisible) {
                  if (_this12.model.platform.indexOf('ios') !== -1) {
                    apps.push({
                      app_url: _this12.model.appUrl,
                      app_name: _this12.model.appName,
                      app_icon: _this12.model.appIcon,
                      platform: 'ios'
                    });
                  }
                  if (_this12.model.platform.indexOf('android') !== -1) {
                    apps.push({
                      app_url: _this12.model.appUrl,
                      app_name: _this12.model.appName,
                      app_icon: _this12.model.appIcon,
                      platform: 'android'
                    });
                  }
                }
                if (_this12.iOSAppInfoVisible) {
                  apps.push({
                    app_url: _this12.model.iOSAppUrl,
                    app_name: _this12.model.iOSAppName,
                    app_icon: _this12.model.iOSAppIcon,
                    platform: 'ios'
                  });
                }
                if (_this12.androidAppInfoVisible) {
                  apps.push({
                    app_url: _this12.model.androidAppUrl,
                    app_name: _this12.model.androidAppName,
                    app_icon: _this12.model.androidAppIcon,
                    platform: 'android'
                  });
                }

                utils = {
                  create: function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                      var params, res, _$get, project_id, success, message, _$get2, _project_id, template_id;

                      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              params = {
                                project_type: _this12.type,
                                template_id: _this12.templateId,
                                name: _this12.model.name
                                // 通用模板创建需要传 skinId
                              };
                              if (_this12.skinId) {
                                params.skin_id = _this12.skinId;
                              }
                              // 互动视频编辑器创建需要指定type为 iv，ps创建时不传默认为normal
                              if (_this12.isIvType) {
                                params.type = 'iv';
                              }
                              // 创建空白模板/互动视频编辑器才有 orientation 字段
                              if (_this12.isPlaySmartType || _this12.isIvType) {
                                params.orientation = _this12.model.orientation;
                              }
                              if (_this12.isPlaySmartByPsdType) {
                                params.lang = _this12.model.language;
                                params.psd_file = _this12.model.psdUrl;
                                params.quality = _this12.model.quality;
                                _this12.psdSuccess = null;
                                _this12.psdMessage = [];
                              }
                              // 自由编辑固定适配方式
                              if (_this12.isFreeEdit) {
                                params.orientation = 3;
                              }
                              res = void 0;

                              if (!_this12.createRequest) {
                                _context7.next = 13;
                                break;
                              }

                              _context7.next = 10;
                              return _this12.createRequest(params);

                            case 10:
                              res = _context7.sent;
                              _context7.next = 17;
                              break;

                            case 13:
                              params.template_type = _this12.skinId ? 'system' : 'custom';
                              _context7.next = 16;
                              return createGmakerProject(params);

                            case 16:
                              res = _context7.sent;

                            case 17:
                              _this12.sendTrackEvent({
                                pid: _.get(res, 'data.data.project_id') || 0,
                                project_type: _this12.type === 'normal' ? 'gm' : 'ps'
                              });
                              if (_this12.isPlaySmartByPsdType) {
                                _$get = _.get(res, 'data.data'), project_id = _$get.project_id, success = _$get.success, message = _$get.message;

                                if (success) {
                                  _this12.$emit('create-success', {
                                    id: project_id
                                  });
                                  _this12.$refs.psdItem.clearPsd();
                                } else {
                                  _this12.psdSuccess = false;
                                  _this12.psdMessage = message;
                                }
                              } else {
                                _$get2 = _.get(res, 'data.data'), _project_id = _$get2.project_id, template_id = _$get2.template_id;


                                _this12.$emit('create-success', {
                                  id: _project_id,
                                  templateId: template_id
                                });
                              }

                            case 19:
                            case 'end':
                              return _context7.stop();
                          }
                        }
                      }, _callee7, _this12);
                    }));

                    return function create() {
                      return _ref3.apply(this, arguments);
                    };
                  }(),

                  copy: function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                      var params, res, _$get3, project_id, template_id;

                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              params = {
                                project_type: _this12.type,
                                copy_project_id: _this12.id,
                                name: _this12.model.name
                                // 只有复制是 playsmart/iv 数据时才有 orientation 字段
                              };
                              if (_this12.isPlaySmartType || _this12.isIvType) {
                                params.orientation = _this12.model.orientation;
                              }
                              // 互动视频编辑器复制需要指定type为 iv，ps复制时不传默认为normal
                              if (_this12.isIvType) {
                                params.type = 'iv';
                              }
                              // 固定自由编辑
                              if (_this12.isFreeEdit) {
                                params.orientation = 3;
                              }

                              // 因为复制时候 app 信息非必填，所以需要判断是否有 app 相关信息
                              if (_this12.model.promotedType) {
                                params.promoted_type = _this12.model.promotedType;
                              }

                              if (apps && apps.length) {
                                params.apps = _JSON$stringify(apps);
                              }

                              res = void 0;

                              if (!_this12.createRequest) {
                                _context8.next = 13;
                                break;
                              }

                              _context8.next = 10;
                              return _this12.createRequest(params);

                            case 10:
                              res = _context8.sent;
                              _context8.next = 16;
                              break;

                            case 13:
                              _context8.next = 15;
                              return createGmakerProject(params);

                            case 15:
                              res = _context8.sent;

                            case 16:
                              _$get3 = _.get(res, 'data.data'), project_id = _$get3.project_id, template_id = _$get3.template_id;

                              _this12.sendTrackEvent({
                                pid: project_id || 0,
                                project_type: _this12.type === 'normal' ? 'gm' : 'ps'
                              });
                              _this12.$emit('copy-success', {
                                id: project_id,
                                templateId: template_id
                              });

                            case 19:
                            case 'end':
                              return _context8.stop();
                          }
                        }
                      }, _callee8, _this12);
                    }));

                    return function copy() {
                      return _ref4.apply(this, arguments);
                    };
                  }(),

                  update: function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                      var params, res;
                      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while (1) {
                          switch (_context9.prev = _context9.next) {
                            case 0:
                              params = {
                                project_id: _this12.id,
                                name: _this12.model.name,
                                promoted_type: _this12.model.promotedType,
                                apps: apps

                                // 只有复制是 playsmart 数据时才有 orientation 字段
                              };
                              if (_this12.isPlaySmartType) {
                                params.orientation = _this12.model.orientation;
                              }
                              res = void 0;

                              if (!_this12.updateRequest) {
                                _context9.next = 9;
                                break;
                              }

                              _context9.next = 6;
                              return _this12.updateRequest(_extends({}, params, {
                                apps: _JSON$stringify(apps)
                              }));

                            case 6:
                              res = _context9.sent;
                              _context9.next = 12;
                              break;

                            case 9:
                              _context9.next = 11;
                              return updateGmakerProject(_extends({}, params, {
                                apps: _JSON$stringify(apps)
                              }));

                            case 11:
                              res = _context9.sent;

                            case 12:
                              console.log(res);

                              _this12.$emit('update-success', {
                                id: _this12.id,
                                name: _this12.model.name,
                                apps: apps
                              });

                            case 14:
                            case 'end':
                              return _context9.stop();
                          }
                        }
                      }, _callee9, _this12);
                    }));

                    return function update() {
                      return _ref5.apply(this, arguments);
                    };
                  }()
                };
                _context10.prev = 19;

                _this12.updateLoading(true);
                _context10.next = 23;
                return utils[_this12.action]();

              case 23:
                _this12.updateLoading(false);
                _context10.next = 30;
                break;

              case 26:
                _context10.prev = 26;
                _context10.t0 = _context10['catch'](19);

                console.error(_context10.t0);
                _this12.updateLoading(false);

              case 30:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[19, 26]]);
      }))();
    },
    updateLoading: function updateLoading(val) {
      this.$emit('update:loading', val);
    },
    updatePsdSuccess: function updatePsdSuccess(val) {
      this.psdSuccess = val;
    }
  }
};